import React from 'react';
import Loadable from 'react-loadable';
import { Loading } from '../../components';

const routes = [
  {
    path: '/',
    exact: true,
    component: Loadable({
      loader: () => import(/* webpackChunkName:'mallIndex' */ './page/index/index'),
      loading() {
        return <Loading/>;
      },
    }),
  },
  {
    path: '/rule',
    exact: true,
    component: Loadable({
      loader: () => import(/* webpackChunkName:'rule' */ './page/rule/index'),
      loading() {
        return <Loading/>;
      },
    }),
  },
  {
    path: '/record',
    exact: true,
    component: Loadable({
      loader: () => import(/* webpackChunkName:'rule' */ './page/record/index'),
      loading() {
        return <Loading/>;
      },
    }),
  },
];

export default routes;

